import AsyncStorage from '@react-native-async-storage/async-storage';

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

// Local union instead of the IdpvStatus type to avoid a circular import with
// kyc/screens/Idpv/utils, which consumes this store. Only the two terminal
// outcomes are meaningful to force.
export type IdpvStatusOverride = 'complete' | 'failed';

export const IDPV_STATUS_OVERRIDES: IdpvStatusOverride[] = ['complete', 'failed'];

type IdpvStatusOverrideStore = {
    enabled: boolean;
    status: IdpvStatusOverride;
    actions: {
        setEnabled: (enabled: boolean) => void;
        setStatus: (status: IdpvStatusOverride) => void;
        reset: () => void;
    };
};

/**
 * Dev-only override for the IDPV status poll so QA can force the verification
 * outcome (success / failure) from the Developer screen, regardless of the
 * provider's verdict. Consumed by useGetIdpvStatus.
 */
export const useIdpvStatusOverrideStore = create<IdpvStatusOverrideStore>()(
    persist(
        set => ({
            enabled: false,
            status: 'complete',
            actions: {
                setEnabled: (enabled: boolean) => set({ enabled }),
                setStatus: (status: IdpvStatusOverride) => set({ status }),
                reset: () => set({ enabled: false, status: 'complete' }),
            },
        }),
        {
            name: 'idpvStatusOverride-storage',
            version: 1,
            storage: createJSONStorage(() => AsyncStorage),
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            partialize: ({ actions, ...rest }: IdpvStatusOverrideStore) => rest,
        }
    )
);
